<template>
  <svg fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.25 16.5H13.5C12.672 16.5 12 15.828 12 15V11.25C12 10.836 11.664 10.5 11.25 10.5H10.5" :style="[strokeStyle]" stroke-linecap="round" stroke-linejoin="round" class="fill-none"/>
    <path d="M11.625 6.75C11.418 6.75 11.25 6.918 11.25 7.125C11.25 7.332 11.418 7.5 11.625 7.5C11.832 7.5 12 7.332 12 7.125C12 6.918 11.832 6.75 11.625 6.75Z" fill="currentColor" stroke="currentColor" :style="[strokeStyle]" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12 0.75C18.213 0.75 23.25 5.787 23.25 12C23.25 18.213 18.213 23.25 12 23.25C5.787 23.25 0.75 18.213 0.75 12C0.75 5.787 5.787 0.75 12 0.75Z" :style="[strokeStyle]" stroke-linecap="round" stroke-linejoin="round" class="fill-none"/>
</svg>


</template>

<script>
const IconMixin = require("@/mixins/IconMixin").default;
  
export default {
  name: "IconInfo",
  mixins: [IconMixin],
  data() {
    return {};
  },
  props: {
  },
  computed: {

  }
}
</script>